import { useFeatureToggle } from '@hotelplan/libs.feature-toggle';
import { FeatureList } from 'config/pageConfig.constants';

export const useFdrCO2EmissionFeatureToggle = (): boolean => {
  const { getVariant } = useFeatureToggle();
  const variant = getVariant(FeatureList.SHOW_KLIMALINK);

  return variant?.enabled && variant?.name === 'show';
};
